import { render, staticRenderFns } from "./TmpPhoto.vue?vue&type=template&id=ca560816&lang=pug&"
import script from "./TmpPhoto.vue?vue&type=script&lang=js&"
export * from "./TmpPhoto.vue?vue&type=script&lang=js&"
import style0 from "./TmpPhoto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VFileInput})
